export default __webpack_public_path__ + "static/media/reembolsoFinalizado.bc17daf7.svg";